// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"bav_a","InstagramEmbed__mask":"bav_b bhp_bi bhp_bo bhp_wz"};